import { render, staticRenderFns } from "./ShowerConfiguratorStandalone.vue?vue&type=template&id=2db71c3d&"
import script from "./ShowerConfiguratorStandalone.ts?vue&type=script&lang=js&"
export * from "./ShowerConfiguratorStandalone.ts?vue&type=script&lang=js&"
import style0 from "./ShowerConfiguratorStandalone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports